import { useEffect, useRef } from 'react';

const CustomCursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(hover: none)').matches) return;

    const style = document.createElement('style');
    style.textContent = '*, *::before, *::after { cursor: none !important; }';
    document.head.appendChild(style);

    const cursor = cursorRef.current;
    let x = -100, y = -100;
    let raf;

    const onMouseMove = (e) => {
      x = e.clientX;
      y = e.clientY;
    };

    const onMouseOver = (e) => {
      const el = e.target.closest('a, button, [role="button"], input, select, textarea, label, [tabindex]');
      if (cursor) {
        cursor.style.width = el ? '32px' : '20px';
        cursor.style.height = el ? '32px' : '20px';
      }
    };

    const render = () => {
      if (cursor) {
        cursor.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`;
      }
      raf = requestAnimationFrame(render);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseover', onMouseOver);
    raf = requestAnimationFrame(render);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseover', onMouseOver);
      cancelAnimationFrame(raf);
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '1.5px solid #181818',
        pointerEvents: 'none',
        zIndex: 999999,
        backgroundColor: 'transparent',
        transition: 'width 0.2s ease, height 0.2s ease',
      }}
    />
  );
};

export default CustomCursor;
